export enum SeverityType {
	Error,
	Warning,
}
